<template>
  <Dialog
    :visible="visible"
    modal
    header="Welcome!"
    @update:visible="$emit('update:visible', $event)"
    :pt="{
      content: {
        style: {
          maxWidth: '600px',
        },
      },
    }"
  >
    <div>
      <p>Thank you for being here! Here is a
        list of a few of the many reasons to join us at ekoz.ai.</p>

      <div class="font-bold">Hosts</div>
      <ul>
        <li>Easy, free account setup</li>
        <li>Participate in more premium host read campaigns</li>
        <li>Command higher CPMs than prerecorded ads</li>
        <li>Hear and approve every ad</li>
        <li>Automated ad creation and zero production</li>
        <li>Your voice "eko" served only in your show</li>
        <li>Better experience for listeners</li>
        <li>Fill unsold inventory</li>
      </ul>

      <div class="font-bold">Advertisers</div>
      <ul>
        <li>Host-read ads planned, bought, delivered, and reported, at scale, programmatically</li>
        <li>Host read ads offer far greater performance than prerecorded</li>
        <li>More advanced tracking, targeting, and optimization</li>
        <li>Easy to test messages and generate fresh content</li>
        <li>Faster to market with no production or process lag time</li>
        <li>A unique offering to bring scale to the influencer media segment</li>
      </ul>
    </div>
    <template #footer>
      <div class="flex justify-content-end">
        <Button
          label="Close"
          @click="$emit('update:visible', false)"
        />
      </div>
    </template>
  </Dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
